export function buildDiff(paragraphsA = [], paragraphsB = []) {
    const a = {};
    const b = {};
    const length = Math.max(paragraphsA.length, paragraphsB.length);

    for (let index = 0; index < length; index++) {
        const paragraphA = paragraphsA[index];
        const paragraphB = paragraphsB[index];
        const keyA = paragraphA?.paragraphId || String(index);
        const keyB = paragraphB?.paragraphId || String(index);

        if (paragraphA && paragraphB) {
            const unchanged = paragraphA.text?.trim() === paragraphB.text?.trim();
            a[keyA] = unchanged ? "unchanged" : "changed";
            b[keyB] = unchanged ? "unchanged" : "changed";
        } else if (paragraphA) {
            a[keyA] = "removed";
        } else if (paragraphB) {
            b[keyB] = "added";
        }
    }
    return { a, b };
}
